import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-unsaved-changes-dialog',
  templateUrl: './unsaved-changes-dialog.component.html',
  styleUrls: ['./unsaved-changes-dialog.component.scss'],
  standalone: false,
})
export class UnsavedChangesDialogComponent {
  constructor(
    private dialogRef: MatDialogRef<UnsavedChangesDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      title: string;
      message: string;
      confirmButtonLabel?: string;
      cancelButtonLabel?: string;
    },
  ) {
    this.data.confirmButtonLabel = this.data.confirmButtonLabel || 'Leave';
    this.data.cancelButtonLabel = this.data.cancelButtonLabel || 'Stay';
  }

  stay(): void {
    this.dialogRef.close(false);
  }

  leave(): void {
    this.dialogRef.close(true);
  }
}
